<template>
  <div>
    <el-row>
      <el-col>
        <el-button size="medium" @click="addProduct" style="margin-top:20px">新增产品</el-button>
        <el-button size="medium" @click="exportProduct" type="primary" plain style="margin-top:20px">导出</el-button>
        <el-button size="medium" @click="importProduct" style="margin-top:20px">导入</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="20">
        <el-form :model="searchForm" ref="searchForm" :inline="true" style="margin-top:20px">
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="querySearch">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData" style="margin-top:20px">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="产品编码" prop="PRODUCT_CODE"></el-table-column>
          <el-table-column label="产品名称" prop="NAME"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="安全库存" prop="SAFETY_STOCK"></el-table-column>
          <el-table-column label="出库方式" prop="TYPE_UNIT">
            <template slot-scope="scope">
              <el-tag>{{ showList[scope.row.OW_TYPE - 1] }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="出成比例" prop="BUY_RATE"></el-table-column>
          <el-table-column label="原料产地" prop="PRODUCING_AREA"></el-table-column>
          <el-table-column label="保质期">
            <template slot-scope="scope">
              <span>{{ scope.row.QGP + QGP_TIME_TYPE[scope.row.QGP_TIME_TYPE] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="购买产品" prop="BUYED_NAME"></el-table-column>
          <el-table-column label="购买单位" prop="BUYED_TYPE_UNIT"></el-table-column>
          <el-table-column label="状态" prop="STATUS">
            <template slot-scope="scope">
              <span>{{ showStatus[scope.row.STATUS] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200px">
            <template slot-scope="scope">
              <el-button type="text" @click="deleteProduct(scope.row)">删除</el-button>
              <el-button type="text" @click="openEdit(scope.row)">修改</el-button>
              <el-button type="text" @click="openEditBuy(scope.row)">修改购买产品</el-button>
              <el-button type="text" style="color: red" v-if="scope.row.STATUS == 1" @click="stopProduct(scope.row)">禁用
              </el-button>
              <el-button type="text" v-else @click="startProduct(scope.row)">启用</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 导入价格 -->
    <el-dialog title="导入" center :visible.sync="addFormVisible" width="500px">
      <el-form ref="addForm" v-model="addForm" style="margin-left: 30px">
        <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-success="handleSuccess" :on-remove="handleRemove"
          :name="this.addForm.price" multiple :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <p @click="downLoadTmp">点击下载模板</p>
          <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
        </el-upload>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeImport('addForm')">取 消</el-button>
        <el-button @click="submitEnter('addForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改出库方式 -->
    <el-dialog title="修改出库方式" center :visible.sync="editFormVisible" width="500px">
      <el-form ref="editForm" v-model="editForm" style="margin-left: 30px" label-width="90px">
        <el-form-item label="出库方式：">
          <el-select filterable v-model="editForm.OW_TYPE" style="width: 100%">
            <el-option v-for="item in OWLists" :key="item.ID" :value="item.ID" :label="item.NAME"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出成比例：">
          <el-input v-model="editForm.BUY_RATE"></el-input>
        </el-form-item>
        <el-form-item label="原料产地：">
          <el-input v-model="editForm.PRODUCING_AREA"></el-input>
        </el-form-item>
        <el-form-item label="保质期：">
          <el-input v-model="editForm.EXPIRATION_DAY"></el-input>
        </el-form-item>
        <el-form-item label="安全库存：">
          <el-input v-model="editForm.SAFETY_STOCK"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeEdit('editForm')">取 消</el-button>
        <el-button @click="submitEdit('editForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改购买产品 -->
    <el-dialog title="修改购买产品" center :visible.sync="buyFormVisible" width="500px">
      <el-form ref="buyForm" v-model="buyForm" style="margin-left: 30px" label-width="100px">
        <el-form-item label="购买产品：">
          <el-autocomplete class="inline-input" v-model="buyForm.productName" :fetch-suggestions="querySearchProduct" placeholder="请输入产品名称"
            :trigger-on-focus="false" @select="handleSelect" clearable style="width: 100%">
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="出成比例：">
          <el-input v-model="buyForm.BUY_RATE"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeBuy('buyForm')">取 消</el-button>
        <el-button @click="submitBuy('buyForm')">确 定</el-button>
      </div>
    </el-dialog>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination :current-page.sync="currentPage" :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totalCount"
          @current-change="handleCurrentChange"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      // loading: false,
      addForm: {
        price: 'tmp',
      },
      fileList: [],
      addFormVisible: false,
      url: '',
      name: '',
      nowPrice: '',
      editForm: {},
      formLabelWidth: '120px',
      editFormVisible: false,
      tableData: [],
      kindsId: sessionStorage.getItem('kindId'),
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      searchForm: {},
      showList: ['MTO', 'MTS', 'DS'],
      OWLists: [
        {
          ID: '1',
          NAME: 'MTO',
        },
        {
          ID: '2',
          NAME: 'MTS',
        },
        {
          ID: '3',
          NAME: 'DS',
        },
      ],
      buyFormVisible: false,
      buyForm: {},
      PRODUCT_NAME: '',
      TYPE_UNIT: '',
      showStatus: ['已禁用', '在用'],
      QGP_TIME_TYPE: ['', '年', '季', '个月', '天', '小时'],
    };
  },
  methods: {
    // ---------------------导入
    importProduct() {
      this.addFormVisible = true;
    },
    closeImport(formName) {
      this.$refs[formName].resetFields();
      const modalName = `${formName}Visible`;
      this[`${modalName}`] = false;
      this.fileList = [];
    },
    handleSuccess(response, file, fileList) {
      this.url = response.file_name;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.url = '';
    },
    removeFile(file, fileList) {
      this.remove = file.uid;
      this.idArray.push({ ID: this.remove });
    },
    submitEnter() {
      if (!this.url) {
        this.$message.show({ text: '请先上传文件', type: 'warning' });
        return false;
      }
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10050',
            OTYPE: 10,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            GYS_ID: Number(sessionStorage.getItem('tcId')),
            CATALOG_ID: Number(this.kindsId),
            FILE_NAME: this.url,
          };
          http.post(params).then((result) => {
            this.$message.show({ text: '导入成功', type: 'success' });
            this.url = '';
            this.$refs.upload.clearFiles();
            this.addFormVisible = false;
            this.fileList = [];
            this.queryTable();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            this.url = '';
            this.$refs.upload.clearFiles();
            document.body.style.cursor = 'default';
          });
        } finally {
          document.body.style.cursor = 'default';
        }
      }
    },
    close() {
      this.editFormVisible = false;
      this.queryTable();
    },
    exportProduct() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10050',
            OTYPE: 8,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            GYS_ID: Number(sessionStorage.getItem('tcId')),
            CATALOG_ID: Number(this.kindsId),
          };
          http.post(params).then((result) => {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    addProduct() {
      this.$router.push({ name: 'addKindProduct' });
      sessionStorage.setItem('kindId', this.kindsId);
    },
    matchProduct() {
      this.$router.push({ name: 'matchKindProduct' });
    },
    queryTable() {
      const params = {
        SERVICE_ID: '10050',
        OTYPE: 4,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        CATALOG_ID: Number(this.kindsId),
      };
      if (this.searchForm.name) {
        params.PRODUCT_NAME = this.searchForm.name;
      }
      http.post(params).then((result) => {
        if (result[0]) {
          this.tableData = result[0].list;
          this.totalCount = result[0].TOTAL_COUNT;
        } else {
          this.tableData = [];
          this.totalCount = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    querySearch() {
      this.currentPage = 1;
      this.queryTable();
    },
    // 解除绑定
    deleteProduct(row) {
      this.$confirm('此操作会将从采购列表中下架，不能继续采购, 是否继续操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          SERVICE_ID: '10050',
          OTYPE: 3,
          USER_ID: sessionStorage.getItem('userId'),
          SESSION: sessionStorage.getItem('session'),
          GYS_ID: sessionStorage.getItem('tcId'),
          PRODUCT_ID: row.ID,
          CATALOG_ID: Number(this.kindsId),
        };
        http.post(params).then((result) => {
          this.$message.show({ text: '删除成功', type: 'success' });
          this.queryTable();
          document.body.style.cursor = 'default';
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          document.body.style.cursor = 'default';
        });
      }).catch(() => {
        this.$message.show({
          text: '取消操作',
          type: 'warning',
        });
      });
    },
    handleCurrentChange() {
      this.queryTable();
    },
    openEdit(row) {
      this.editFormVisible = true;
      this.editForm = row;
      this.editForm.OW_TYPE = String(row.OW_TYPE);
    },
    submitEdit() {
      const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (!reg.test(this.editForm.BUY_RATE)) {
        this.$message.show({ text: '请输入正确的出成比例', type: 'warning' });
        return false;
      }
      if (!reg.test(this.editForm.EXPIRATION_DAY)) {
        this.$message.show({ text: '请输入正确的保质期', type: 'warning' });
        return false;
      }
      if (!reg.test(this.editForm.SAFETY_STOCK)) {
        this.$message.show({ text: '请输入正确的安全库存', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10050',
        OTYPE: 7,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        CATALOG_ID: Number(this.kindsId),
        PRODUCT_CODE: this.editForm.PRODUCT_CODE,
        OW_TYPE: this.editForm.OW_TYPE,
        BUY_RATE: this.editForm.BUY_RATE,
        EXPIRATION_DAY: this.editForm.EXPIRATION_DAY ? this.editForm.EXPIRATION_DAY : '',
        PRODUCING_AREA: this.editForm.PRODUCING_AREA ? this.editForm.PRODUCING_AREA : '',
        SAFETY_STOCK: this.editForm.SAFETY_STOCK,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.editFormVisible = false;
        this.queryTable();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    closeEdit() {
      this.editFormVisible = false;
    },
    downLoadTmp() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/gysUsingCatalogSKUTemp.xls';
    },
    openEditBuy(row) {
      this.buyFormVisible = true;
      this.buyForm = row;
    },
    submitBuy() {
      const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (!this.buyForm.productName || !this.buyForm.BUY_RATE) {
        this.$message.show({ text: '请输入购买产品和出成比例', type: 'warning' });
        return false;
      }
      if (!reg.test(this.buyForm.BUY_RATE)) {
        this.$message.show({ text: '请输入正确的出成比例', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10050',
        OTYPE: 12,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        BUYED_PRODUCT_CODE: this.PRODUCT_CODE,
        DETAIL_ID: this.buyForm.ID,
        BUY_RATE: this.buyForm.BUY_RATE,
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.buyFormVisible = false;
        this.queryTable();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    closeBuy() {
      this.buyFormVisible = false;
    },
    // ------------------搜索
    querySearchProduct(queryString, callback) {
      const params = {
        SERVICE_ID: '10050',
        OTYPE: 13,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        NAME: queryString,
      };
      http.post(params).then((res) => {
        const tmpArr = res.map((item) => Object.assign(item));
        const results = tmpArr.map((item) => {
          item.value = `${item.NAME}(${item.TYPE_UNIT})`;
          return item;
        });
        callback(results);
      });
    },
    //  点击搜索结果返回选中的结果
    handleSelect(item) {
      this.PRODUCT_CODE = item.PRODUCT_CODE;
    },
    stopProduct(row) {
      const params = {
        SERVICE_ID: '10008',
        OTYPE: 29,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PRODUCT_CODE: row.PRODUCT_CODE,
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '禁用成功', type: 'success' });
        this.queryTable();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    startProduct(row) {
      const params = {
        SERVICE_ID: '10008',
        OTYPE: 30,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PRODUCT_CODE: row.PRODUCT_CODE,
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '启用成功', type: 'success' });
        this.queryTable();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryTable();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/systemSetting/kindProduct.vue